<template>
<div class="txtWrap">
  <div class="txtcot">
    <div class="txttitle">添加文字</div>
    <div class="txtereacot">文字不超过18个字</div>
    <input :value="txt"
           @input="iptfn"
           :placeholder="placeholder"
           class="iptcls"/>
    <div class="txtgroup">
      <div class="txtcancel" @click="cancelfn">取消</div>
      <div class="txtsure" @click="onSubmit">确定</div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'txtarea',
  props: {
    maxlength: {
      default: 18,
      type: Number
    },
    txt: {
      default: '',
      type: String
    },
    placeholder: {
      default: '请输入文字',
      type: String
    }
  },
  methods: {
    onSubmit () {
      this.$emit('onSureTxt')
    },
    iptfn (e) {
      this.$emit('onIpt', e)
    },
    cancelfn () {
      this.$emit('onClose')
    }
  }
}
</script>

<style scoped>
.txtWrap{
  position:fixed;
  left:0;
  top:0;
  width:100%;
  height:100%;
  background-color: rgba(0,0,0,0.28);
  z-index: 1
}
.iptcls{
  width:4.74rem;
  height:.48rem;
  text-indent: 1em;
  border:1px solid rgba(77, 77, 77, 0.78);
  display: block;
  margin:.42rem auto .24rem;
  font-size: .26rem;
  background-color: white;
}
.txtcot{
  width:5.4rem;
  background-color: rgba(252, 252, 252, 1);
  border-radius: .24rem;
  padding-top: .36rem;
  position:absolute;
  left:50%;
  top:40%;
  transform: translate(-50%,-50%);
  transform: -webkit-translate(-50%,-50%);
}
.txttitle,.txtereacot{
  text-align: center;
  font-size: .26rem;
  color:#030303;
}
.txttitle{
  font-size: .34rem;
  font-weight: bold;
  margin-bottom: .12rem;
}
.txtgroup{
  display: flex;
  display: -webkit-flex;
  border-top:1px solid rgba(48, 49, 51, 0.08);
  height:.88rem;
  line-height: .88rem;
  align-items: center;
  font-size: .34rem;
  color:rgba(48, 49, 51, 1);
}
.txtsure,.txtcancel{
  flex-basis: 50%;
  text-align: center;
  height:.88rem;
  color:rgba(0, 122, 255, 1);
}
.txtcancel{
  border-right:1px solid rgba(48, 49, 51, 0.08);
}
.txtsure{
  border:none;
}
</style>
